import { HttpService } from "@/core";
import { ExportReq, ExportResp } from "@/core/interface";
import {
  ChangeDetailResp,
  ChangePageReq,
  ChangePageResp,
  ChangeReq,
  ChangeSimpleListReq,
  ChangeSimpleListResp,
} from "./change.interface";

export class ChangeService {
  static usePageApi() {
    const api = (params: ChangePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/safety_change/page",
        params,
      });
    return HttpService.usePagination<ChangePageResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/safety_change/${id}`,
      });
    return HttpService.useRequest<ChangeDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: ChangeReq) =>
      HttpService.axios({
        method: "POST",
        url: "/safety_change",
        data,
      });
    return HttpService.useRequest<ChangeDetailResp>(api);
  }

  static useEditApi() {
    const api = (id: string, data: ChangeReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/safety_change/${id}`,
        data,
      });
    return HttpService.useRequest<ChangeDetailResp>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/safety_change/${id}`,
      });
    return HttpService.useRequest<ChangeDetailResp>(api);
  }

  static useExportApi() {
    const api = (ids: ExportReq) =>
      HttpService.axios({
        method: "GET",
        url: "/safety_change/export",
        params: { ids },
      });
    return HttpService.useRequest<ExportResp>(api);
  }

  static useSimpleListApi() {
    const api = (params: ChangeSimpleListReq) =>
      HttpService.axios({
        method: "GET",
        url: "/safety_change/simple/list",
        params,
      });
    return HttpService.useRequest<ChangeSimpleListResp>(api);
  }

  static async backfillByChangeId(changeId): Promise<ChangeReq> {
    let result = new ChangeReq();
    if (!changeId) {
      return result;
    }
    const { run } = ChangeService.useDetailApi();
    const res = await run(changeId);
    if (res.respCode === "0000" && res.data) {
      result.pick(res.data);
    }
    return result;
  }
}
